"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.Style = exports.CSS = void 0;
var theme_1 = require("../../../components/theme");
exports.CSS = {
    container: 'c-ExportNotificationDetail',
    field: 'c-ExportNotificationDetail__Field',
    form: 'c-ExportNotificationDetail__Form',
    reason: 'c-ExportNotificationDetail__Reason',
    default: 'c-ExportNotificationDetail__Default'
};
exports.Style = (_a = {},
    _a[exports.CSS.field] = {
        'font-weight': theme_1.DefaultTheme.font.weight.bold
    },
    _a);
//# sourceMappingURL=export.notification.detail.style.js.map